module.exports = __webpack_public_path__ + "static/media/processed_food.cd0ff374.svg";